import React, { useEffect, useState, useRef, Component } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useTheme } from '../../core/contexts/ThemeContext';
import { useWindows } from '../../core/contexts/WindowContext';
import { useAppRegistry } from '../../core/contexts/AppRegistry';
import { Window } from './Window';
import { Dock } from './Dock';
import { MenuBar } from './MenuBar';
import { CommandPalette } from './CommandPalette';
import { AppInitializer } from './AppInitializer';
import { BootSequence } from './BootSequence';
function EmptyDesktop() {
  const {
    theme
  } = useTheme();
  const isLightTheme = theme === 'light';
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95,
    filter: 'blur(10px)'
  }} animate={{
    opacity: 1,
    scale: 1,
    filter: 'blur(0px)'
  }} exit={{
    opacity: 0,
    scale: 0.95,
    filter: 'blur(10px)'
  }} transition={{
    duration: 1.2,
    ease: 'easeOut'
  }} className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none z-0" data-id="element-188">
      <div className="flex flex-col items-center gap-6" data-id="element-189">
        <h1 className={`text-7xl md:text-9xl font-medium tracking-tighter m-0 ${isLightTheme ? 'text-black/[0.08]' : 'text-white/[0.08]'}`} data-id="element-190">
          {time.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </h1>
        <div className="flex flex-col items-center gap-2" data-id="element-191">
          <h2 className={`text-xl md:text-2xl font-medium tracking-tight m-0 ${isLightTheme ? 'text-black/40' : 'text-white/40'}`} data-id="element-192">
            MvlCreative
          </h2>
          <span className={`font-mono text-[10px] tracking-widest uppercase ${isLightTheme ? 'text-black/20' : 'text-white/20'}`} data-id="element-193">
            MvlCreative OS v2.0
          </span>
        </div>
      </div>
    </motion.div>;
}
export function Desktop() {
  const {
    theme,
    t
  } = useTheme();
  const {
    windows,
    openWindow
  } = useWindows();
  const {
    getAppById
  } = useAppRegistry();
  const isLightTheme = theme === 'light';
  const [isBooting, setIsBooting] = useState(true);
  const hasOpenedHome = useRef(false);
  // Auto-open Home window ONCE after boot completes
  useEffect(() => {
    if (!isBooting && !hasOpenedHome.current) {
      hasOpenedHome.current = true;
      const timer = setTimeout(() => {
        openWindow('home', t('home.title'));
      }, 2500); // Wacht 2.5 seconden zodat de gebruiker de lege desktop/klok ziet
      return () => clearTimeout(timer);
    }
  }, [isBooting]);
  return <div className={`w-full min-h-screen relative overflow-hidden ${isLightTheme ? 'wallpaper-light' : 'wallpaper-dark'}`} data-id="element-194">
      <AppInitializer data-id="element-195" />

      <AnimatePresence data-id="element-196">
        {isBooting && <BootSequence onComplete={() => setIsBooting(false)} data-id="element-197" />}
      </AnimatePresence>

      {!isBooting && <>
          <MenuBar data-id="element-198" />
          <CommandPalette data-id="element-199" />

          {/* Empty Desktop State */}
          <AnimatePresence data-id="element-200">
            {windows.every(w => w.isMinimized) && <EmptyDesktop data-id="element-201" />}
          </AnimatePresence>

          {/* Windows Layer */}
          <div className="absolute inset-0 pt-10 pb-20 pointer-events-none z-10" data-id="element-202">
            <AnimatePresence data-id="element-203">
              {windows.map(window => {
            const app = getAppById(window.appId);
            if (!app) return null;
            const AppComponent = app.component;
            return <Window key={window.id} window={window} data-id="element-204">
                    <AppComponent projectId={window.projectId} data-id="element-205" />
                  </Window>;
          })}
            </AnimatePresence>
          </div>

          <Dock data-id="element-206" />
        </>}
    </div>;
}